import { defineMessages } from 'react-intl';

export const accountingHeadersMessages = defineMessages({
    accountingHeaders: {
        id: 'accounting-headers',
        defaultMessage: 'Accounting headers',
    },
    headers: {
        id: 'headers',
        defaultMessage: 'Headers',
    },
    header: {
        id: 'header',
        defaultMessage: 'Header',
    },
    accountNumber: {
        id: 'account-number',
        defaultMessage: 'Account number',
    },
    partide: {
        id: 'partide',
        defaultMessage: 'Partide',
    },
    parent: {
        id: 'parent',
        defaultMessage: 'Parent',
    },
    billingEntity: {
        id: 'billing-entity',
        defaultMessage: 'Billing entity',
    },
    account: {
        id: 'account',
        defaultMessage: 'Account',
    },
    income: {
        id: 'income',
        defaultMessage: 'Income',
    },
    expense: {
        id: 'expense',
        defaultMessage: 'Expense',
    },
    estimate: {
        id: 'estimate',
        defaultMessage: 'Estimate',
    },
    createAccountingHeadingSuccess: {
        id: 'create-accounting-heading-success',
        defaultMessage: 'Accounting header created',
    },
    createAccountingHeadingSuccessDescription: {
        id: 'create-accounting-heading-success-description',
        defaultMessage: 'Accounting header {entry} has been successfully created.',
    },
    addAccountingHeadingSubtitle: {
        id: 'add-accounting-heading-subtitle',
        defaultMessage: 'Create a new accounting header',
    },
    deleteAccountingHeader: {
        id: 'delete-accounting-header',
        defaultMessage: 'Delete accounting header',
    },
    deleteAccountingHeaderSuccess: {
        id: 'delete-accounting-header-success',
        defaultMessage: 'Accounting header deleted',
    },
    deleteAccountingHeaderSuccessDescription: {
        id: 'delete-accounting-header-success-description',
        defaultMessage: 'The accounting header has been successfully deleted.',
    },
    confirmDeleteAccountingHeader: {
        id: 'confirm-delete-accounting-header',
        defaultMessage: 'Are you sure you want to delete this accounting header? This action cannot be undone.',
    },
    deleteAccountingHeaderSubtitle: {
        id: 'delete-accounting-header-subtitle',
        defaultMessage: 'Permanently delete accounting header {entity}',
    },
    editAccountingHeaderSubtitle: {
        id: 'edit-accounting-header-subtitle',
        defaultMessage: 'Edit accounting header {entity}',
    },
    updateAccountingHeaderSuccess: {
        id: 'update-accounting-header-success',
        defaultMessage: 'Accounting header updated',
    },
    updateAccountingHeaderSuccessDescription: {
        id: 'update-accounting-header-success-description',
        defaultMessage: 'Accounting header {entity} has been successfully updated.',
    },
    searchParent: {
        id: 'search-parent',
        defaultMessage: 'Search for parent',
    },
    noParent: {
        id: 'no-parent',
        defaultMessage: 'No parent',
    },
    noParentFound: {
        id: 'no-parent-found',
        defaultMessage: 'No parent found',
    },
    searchAccountingHeader: {
        id: 'search-accounting-header',
        defaultMessage: 'Search for accounting header',
    },
    noAccountingHeader: {
        id: 'no-accounting-header',
        defaultMessage: 'No accounting header',
    },
    noAccountingHeaderFound: {
        id: 'no-accounting-header-found',
        defaultMessage: 'No accounting header found',
    },
});
